<template>
  <div
    class="
    menu-w color-scheme-dark color-style-default menu-position-side menu-side-left menu-layout-compact sub-menu-style-inside sub-menu-color-dark selected-menu-color-dark menu-activated-on-click menu-has-selected-link"
    style="min-height: 700px; z-index:100">
    <div class="logo-w">
      <a class="logo" href="/">
        <LogoComponent
          :css="'width: 85px;'"
        ></LogoComponent>
        <div class="logo-label">OasisCloud</div>
      </a>
    </div>
    <div class="logged-user-w avatar-inline">
      <div class="logged-user-i">
        <div class="avatar-w">
          <img alt v-bind:src="user.image">
        </div>
        <div class="logged-user-info-w">
          <div class="logged-user-name" v-html="user.name"></div>
          <div class="logged-user-role" v-html="user.email"></div>
        </div>
      </div>
    </div>

    <SideMenuUlComponent />
  </div>
</template>

<script>
import SideMenuUlComponent from "@/layouts/globals/SideMenuUlComponent.vue";
import LogoComponent from "@/components/LogoComponent.vue";

export default {
  components: {
    SideMenuUlComponent,
    LogoComponent
  },
  data() {
    return {
      user: {
        name: "",
        image: "",
        email: ""
      }
    };
  },
  props: {},
  watch: {},
  computed: {
    module() {
      return this.$store.getters.module;
    },
    modules() {
      return this.$store.getters.modules;
    }
  },
  created() {
    this.user.name = localStorage.getItem("name");
    this.user.email = localStorage.getItem("email");
    this.user.image = localStorage.getItem("image");
  },
  mounted() {
  },
  methods: {}
};
</script>
